<template>
  <thead>
    <tr>
      <th>
        <div v-if="firstColumnTitle">
          <p class="title">
            {{ firstColumnTitle }}
          </p>
        </div>
      </th>

      <th
        v-for="columnGroup of header"
        :key="columnGroup.key"
        :colspan="columnGroup.columns.reduce((prev, cur) => (cur.isActive ? prev + 1 : prev), 0)"
      >
        <div class="psui-space-x-1 psui-items-center psui-show-childrens-on-hover">
          <p class="title">
            {{ columnGroup.title }}
          </p>
          <PsIcon
            icon="info_outline"
            size="18"
            class="psui-cursor-pointer psui-text-gray-60 hover:psui-text-blue-60 psui-opacity-0 psui-leading-none psui-transition"            
            :style="{ display: 'flex' }"
            :aria-label="`${columnGroup.title} info`"
            aria-haspopup="true"
            @click="emit('click-column-group-helper', columnGroup, $event)"
            @keydown.enter.stop="emit('click-column-group-helper', columnGroup, $event)"
          />
        </div>
      </th>
    </tr>

    <tr>
      <th>
        <div>
          <p
            v-if="firstColumnDescription"
            class="description"
          >
            {{ firstColumnDescription }}
          </p>
        </div>
      </th>

      <template v-for="columnGroup of header">
        <th
          v-for="column of columnGroup.columns"
          :key="`${columnGroup.key}-${column.key}`"
        >
          <div class="psui-flex psui-flex-col">
            <div class="psui-flex psui-flex-row psui-space-x-1 psui-items-center psui-justify-end psui-show-childrens-on-hover psui-mb-px">
              <PsIcon
                v-if="showOrder"
                :icon="orderDirection == 'asc' ? 'arrow_downward' : 'arrow_upward'"
                :type="orderDirection == 'asc' ? 'arrow_upward' : 'arrow_upward'"
                size="18"
                class="helper psui-cursor-pointer psui-text-blue-50 psui-opacity-0 psui-leading-none psui-transition"                
                :style="{ display: 'flex', marginTop: '1px' }"
                @click="emit('click-order-column', column)"
                @keydown.enter.stop="emit('click-order-column', column)"
              />

              <PsIcon
                icon="info_outline"
                size="18"
                class="helper psui-cursor-pointer psui-text-gray-60 hover:psui-text-blue-60 psui-opacity-0 psui-leading-none psui-transition"                
                :style="{ display: 'flex', marginTop: '1px' }"
                :aria-label="`${column.title} info`"
                aria-haspopup="true"
                :aria-controls="`modal-column-helper-${column.key}`"
                @click="emit('click-column-helper', column, $event)"
                @keydown.enter.stop="emit('click-column-helper', column, $event)"
              />
              <p
                v-tooltip="getTooltip(column)"
                class="title"
                v-if="column.title"
              >
                {{ column.title }}
              </p>
            </div>
            <p
              class="description"
              v-if="column.description && layout != 'flexible'"
            >
              {{ column.description }}
            </p>
          </div>
        </th>
      </template>
    </tr>
  </thead>
</template>

<script setup>
import PsIcon from '../ui/PsIcon.vue'
import { computed, getCurrentInstance } from 'vue'

const props = defineProps({
  /**
   * It sets the title for the first column.
   */
  firstColumnTitle: {
    type: String,
    default: '',
  },
  layout: {
    type: String,
    default: 'results',
    validator: (value) => {
      return ['results', 'comparison', 'flexible'].indexOf(value) !== -1
    },
  },
  /**
   * It sets the description for the first column.
   */
  firstColumnDescription: {
    type: String,
    default: '',
  },
  /**
   * It sets the values which will be use to render the header.
   */
  header: {
    type: Array,
    required: true,
    default: () => {
      return []
    },
  },
  /**
   * this sets whether sorting will be displayed.
   */
  showOrder: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['click-column-group-helper', 'click-order-column', 'click-column-helper'])

const parent = getCurrentInstance().proxy.$parent

const columnsSelectedForStudy = computed(() => {
  return parent.columnsSelectedForStudy
})

const orderColumn = computed(() => {
  return parent.orderColumn
})

const getTooltip = (column) => {
  if(props.layout == 'flexible' && column) {
    return {
    content: column.description,
    classes: 'custom-tooltip'
  }
  }
  return null
}
const orderDirection = computed(() => {
  return parent.orderDirection
})
</script>

<style>
/* Please, use the file src/assets/scss/components/PsTableResults.scss */
</style>
